import React from 'react';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { func, string, bool } from 'prop-types';

import { useDispatch } from 'react-redux';

import Modal from '../../../../modal/Modal';

const ValidationReportModal = ({ title, closeModal, isOpen, generateValidationReport, catalogId }) => {
  const close = () => {
    closeModal();
  };

  const content = () => {
    return <div>Would you like to download the Validation Report?</div>;
  };

  const footer = ({ isLoading, toggleIsLoading }) => {
    const dispatch = useDispatch();
    const handleReportDownload = async () => {
      toggleIsLoading(true, 'Downloading Validation Report...');

      await dispatch(generateValidationReport({ [catalogId]: true }));

      toggleIsLoading();
      closeModal();
    };

    return (
      <>
        <ButtonStyled
          type='button'
          appearance='primary'
          background='light'
          size='small'
          className='responsive-button'
          onClick={handleReportDownload}
          disabled={isLoading}
        >
          Download
        </ButtonStyled>
        <ButtonStyled
          type='button'
          appearance='secondary'
          background='light'
          size='small'
          className='responsive-button'
          onClick={closeModal}
          disabled={isLoading}
        >
          Cancel
        </ButtonStyled>
      </>
    );
  };

  return <Modal title={title} content={content} footer={footer} isOpen={isOpen} closeModal={close} />;
};

ValidationReportModal.propTypes = {
  title: string.isRequired,
  generateValidationReport: func.isRequired,
  closeModal: func.isRequired,
  isOpen: bool.isRequired,
  catalogId: string.isRequired
};

export default ValidationReportModal;
